import { useMemo } from 'react';
import { DateTime } from 'luxon';
import useHttpQuery from 'data/firestore/useHttpQuery';
import { ACTIONS_BASE_URL } from '../../../constants';
import { NexhealthAppointmentList } from '../types';

const useNexhealthAppointments = ({
    agentId,
    customerId,
    months,
    enabled = false,
}: {
    agentId: string;
    customerId: string;
    months: number;
    enabled?: boolean;
}) => {
    const { start, end } = useMemo(() => {
        const now = DateTime.now().startOf('day');
        return {
            start: now.minus({ months }).toISO() || '',
            end: now.plus({ months: months + 1 }).toISO() || '',
        };
    }, [months]);

    return useHttpQuery<NexhealthAppointmentList>({
        pathname: `/organizations/${agentId}/apps/nexhealth/customers/${customerId}/appointments?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}&limit=100`,
        server: ACTIONS_BASE_URL,
        key: ['nexhealth', 'appointments', agentId, customerId, months],
        queryOptions: {
            enabled: Boolean(agentId && customerId) && enabled,
            retry: false,
            keepPreviousData: true,
        },
    });
};

export default useNexhealthAppointments;
